import { useSelector } from "react-redux";
import { getMainState } from "../store/components/Main.slice";
import { MdSpaceDashboard } from "react-icons/md";
import { FaUsersLine } from "react-icons/fa6";
import { FcComboChart } from "react-icons/fc";

import ONEInsight from "../images/svg/ONEInsight.svg";
import ONEAudience from "../images/svg/ONEAudience.svg";
import ONEMarket from "../images/svg/ONEMarket.svg";

import BGRight from "../images/svg/BGRight.svg";
import BGLeft from "../images/svg/BGLeft.svg";
import { useMemo, useState } from "react";
import OneInsightModal, { isHardcodedUser } from "./OneInsightModal";

const items = [
  {
    header: "Discovery",
    appName: "ONE Insight",
    appId: 35,
    appCode: "oneinsightv5",
    appDescription:
      "Leverage A.I. to build highly intelligent personas and workflows.",
    image: ONEInsight,
    icon: <MdSpaceDashboard fill="#1C5C9A" />,
  },
  {
    header: "Set Up",
    appName: "ONE Audience",
    appId: 2,
    appCode: "onemarketaudiencebuilder",
    appDescription: "Access your audience packages here or create a new one.",
    image: ONEAudience,
    icon: <FaUsersLine fill="#1C5C9A" />,
  },
  {
    header: "Campaign Ops",
    appName: "ONE Market",
    appId: 8,
    appCode: "onemarketdsp",
    appDescription: "Activate and manage your digital ad campaigns",
    image: ONEMarket,
    icon: <FcComboChart fill="#1C5C9A" />,
  },
];
export const oneinsightLinkObj = {
  consumer: "https://oneinsight.sqreemtech.com/",
  healthcare: "http://onehealth.sqreemtech.com/",
  government: "https://oneinsight.sqreemtech.com/gov/",
};

function AppList() {
  const { appList, oneInsightPerm } = useSelector(getMainState);
  const [isModalOIOpen, setIsModalOIOpen] = useState(false);

  const apps = useMemo(() => {
    return items.map((item) => {
      const filteredItem = appList.find((app) => item.appId === app.id);
      item.disabled = !filteredItem || !filteredItem?.isActive;
      item.appName = filteredItem?.name || item.appName;
      item.description = filteredItem?.description || item.appDescription;
      item.url = filteredItem?.url;
      return item;
    });
  }, [appList]);

  const onItemClick = (e, appId) => {
    switch (appId) {
      case 35: {
        if (!isHardcodedUser()) {
          if (oneInsightPerm.length === 1) {
            break;
          }
        }
        e.preventDefault();
        setIsModalOIOpen(true);
        break;
      }

      default:
        break;
    }
  };

  const handleOIChoose = (code) => {
    window.open(oneinsightLinkObj[code], "_blank");
  };

  return (
    <div className="app-list d-flex d-flex-col justify-content-center align-items-center h-full">
      <h2 className="app-list-title">ONE</h2>
      <p className="app-list-desc">
        The most powerful end-to-end AI-driven audience intelligence operating
        system for smarter audience planning and targeting.
      </p>

      <div className="app-list-wrapper gap-4 hidden-scrollbar">
        {apps.map(
          ({
            header,
            image,
            appName,
            icon,
            description,
            url: givenUrl,
            disabled: givenDisabled,
            appId,
          }) => {
            let disabled = givenDisabled;
            let url = givenUrl;
            if (appId === 35) {
              if (!oneInsightPerm.length) disabled = true;
              else if (oneInsightPerm.length === 1)
                url = oneinsightLinkObj[oneInsightPerm[0]];
            }
            return (
              <a
                href={url}
                target="blank"
                className={`app-list-item ani-zoomIn ${disabled && "disabled"}`}
                onClick={(e) => {
                  if (disabled) {
                    e.preventDefault();
                    return;
                  }
                  onItemClick(e, appId);
                }}
              >
                <div className="app-list-item-header">{header}</div>
                <div className="app-list-item-image">
                  <img src={image} />
                </div>
                <div className="app-list-item-wrapper d-flex gap-2">
                  <div className="app-list-item-icon">{icon}</div>
                  <div className="d-flex d-flex-col gap-1">
                    <div className="app-list-item-name">{appName}</div>
                    <div className="app-list-item-desc">{description}</div>
                  </div>
                </div>
              </a>
            );
          }
        )}

        <OneInsightModal
          isVisible={isModalOIOpen}
          onOk={handleOIChoose}
          onCancel={() => setIsModalOIOpen(false)}
        />
      </div>

      <img alt="" className="app-list-bg app-list-bg--left" src={BGLeft} />
      <img alt="" className="app-list-bg app-list-bg--right" src={BGRight} />
    </div>
  );
}

export default AppList;
